import authService from './auth.service';

export interface EmailVerificationStatus {
  email: string;
  verified: boolean;
  verified_at: string | null;
}

/**
 * Proof-of-inbox verification (backend migrations 0067 / 0068).
 *
 * The address is never sent from here: the backend always mails the address on
 * file for the authenticated user, so there is nothing to pass and nothing to
 * spoof. The token comes back only in that email.
 */
const emailVerificationService = {
  /** Whether the address currently on the account has been proven. */
  async getStatus(): Promise<EmailVerificationStatus> {
    const { data } = await authService.getApi().get<EmailVerificationStatus>(
      '/api/v1/auth/email/verification',
    );
    return data;
  },

  /**
   * Ask for a fresh link. Any outstanding one is superseded server-side, so the
   * newest email is always the only live one.
   */
  async requestLink(): Promise<void> {
    await authService.getApi().post('/api/v1/auth/email/verification-request');
  },
};

export default emailVerificationService;
